import PropTypes from 'prop-types';

const webinarShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.string,
  content: PropTypes.string,
  published: PropTypes.bool,
  hasDuration: PropTypes.bool
});

export const AddWebinarPropTypes = {
  history: PropTypes.object,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      moduleId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    })
  }),
  snapshot: webinarShape,
  t: PropTypes.func,
  webinar: webinarShape
};
